import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { LoginRouteService } from '../services/login-route.service';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard  {

	constructor(
		private readonly loginRouteService: LoginRouteService,
		private readonly authenticationService: AuthenticationService
	) { }

	canActivate(): Observable<boolean | UrlTree> {
		if (this.authenticationService.isLoggedIn())
			return of(true);

		return this.loginRouteService.redirectToLogin$();
	}
}
